import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './TermsConditions.scss';
import themeStyles from '../../_theme.scss';
import {
    MCO_THEME,
    POL_THEME,
    ThemeContext,
} from '../../constants/theme.ts';

import Button from '../shared/Button/Button';
import * as routes from '../../constants/routes';
import { Titles } from '../../constants/titles';
import { AppContext } from '../../contexts/AppContext';
import { Descriptions } from '../../constants/Descriptions';

const TermsConditions = () => {
    const themeContext = useContext(ThemeContext);
    const { setPageTitle, setPageDescription } = useContext(AppContext);

    useEffect(() => {
        switch (themeContext) {
            case MCO_THEME:
                setPageTitle(Titles.MCO_TERMS);
                setPageDescription(Descriptions.MCO_TERMS);
                break;
            case POL_THEME:
                setPageTitle(Titles.POL_TERMS);
                setPageDescription(Descriptions.POL_TERMS);
                break;
            default:
                break;
        }
    }, [themeContext, setPageTitle, setPageDescription]);

    const privacyPolicy = (
        <a target="_blank" href="https://www.4lpi.com/privacy-policy/" rel="noreferrer">
            Privacy
            Policy
        </a>
    );

    const contactEmail = 'no_reply@4lpi.com';

    const contactEmailLink = ` mailto: ${contactEmail}`;

    let siteTitle = '';
    if (themeContext === POL_THEME) {
        siteTitle = 'Parishes Online';
    } else {
        siteTitle = 'My Community Online';
    }

    return (
        <main className={styles.container}>
            <h1 className={`${themeStyles.headerText} ${styles.headerText}`}>Terms and Conditions</h1>
            <p>
                WELCOME TO LPI’S WEBSITE.
                WE HOPE THAT OUR WEBSITE CAN PROVIDE YOU THE INFORMATION AND CONNECTION THAT YOU ARE LOOKING
                FOR.
                REMEMBER THAT IF YOU USE AND/OR VISIT OUR WEBSITE, YOU AGREE TO ALL OF THE TERMS OF USE NOTED
                BELOW,
                AS WELL AS TO: OUR&nbsp;
                <a
                    className={styles.clearfix}
                    target="_blank"
                    href="https://www.4lpi.com/privacy-policy/"
                    rel="noreferrer"
                >
                    PRIVACY
                    POLICY
                </a>
                &nbsp;AND ANY ADDITIONAL
                TERMS OR RULES MAY BE LISTED ELSEWHERE BUT THEY ARE INCORPORATED INTO THESE TERMS OF USE BY
                REFERENCE.
                PLEASE DO NOT USE THE WEBSITE IF YOU DO NOT AGREE TO ANY OF THESE TERMS OF USE
                BECAUSE ONCE YOU ARE ON OUR WEBSITE
                THESE TERMS OF USE APPLY.
                LPI AND ITS AFFILIATES (“LPi”) RESERVE THE RIGHT IN THEIR SOLE DISCRETION TO DENY ACCESS
                TO ALL OR PART OF OUR WEBSITE WE ALSO RESERVE THE RIGHT TO CHANGE ANY FEATURES ON OUR WEBSITE
                AND
                TO CHANGE THE TERMS AND CONDITIONS AT ANY TIME.
                HERE ARE THE SPECIFIC TERMS OF USE WHICH WE EXPECT YOU TO FOLLOW:
            </p>
            <ol className={styles.termsList}>
                <li>
                    <p>
                        <strong>Ability to Accept Terms of Use.</strong>
                        The Terms of Use forms a legally binding contract
                        between you
                        and us. By using any portion of the Website, you affirm that you
                        are either more than 18 years of age, or an emancipated minor, or
                        possess legal parental or guardian consent, and are fully able
                        and competent to enter into the terms, conditions, obligations,
                        representations and responsibilities set forth in this Agreement,
                        and to abide by and comply with these Terms of Use.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Accounts.</strong>
                        {' '}
                        To use some features of our Website, you may need to create an
                        account. To do so,
                        you must provide correct and complete information. This means you cannot use a false
                        or misleading name or a name that you are not authorized to use. Impersonating another
                        person on our Website is prohibited. You become entirely responsible for the activity
                        that occurs on your account (including any and all charges incurred while your account
                        is being used and liability for harm caused by statements made or materials posted
                        under your account), so be sure to keep your account password secure and tell us
                        immediately if you think there has been unauthorized use of your account.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Our Use of Your Information.</strong>
                        {' '}
                        We respect your information and privacy.
                        Our
                        {' '}
                        {privacyPolicy}
                        {' '}
                        tells you how we approach
                        the collection, use or sharing of
                        Personal Information (as defined in the&nbsp;
                        {privacyPolicy}
                        )
                        . Also, by
                        using our Website, you agree that we are not responsible for any of
                        your Personal Information that you post publicly using our various
                        services such as discussion forums, blogs, or message boards. You
                        can read more about all of this in our
                        {' '}
                        {privacyPolicy}
                        .
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Copyright.</strong>
                        {' '}
                        Everything on or used in connection with our Website, including but
                        not limited to
                        text, images, graphics, logos, audio and video content, software (collectively,
                        &quot;Content&quot;) – with the exception of User Generated Content as defined below –
                        is owned
                        by us and/or our affiliates, subsidiaries, licensors or suppliers. This means that
                        you cannot use the Content without our permission. Here’s what permission we do give
                        you to use the Content. You may only use the Content online for purposes of visiting
                        and using our website, and only for your personal, non-commercial use. This means
                        that you may not download any of our Content, give copies to your friends, display
                        the Content publicly, or charge anything for it. Also, you may not use the Content to
                        construct any kind of database or your own website.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Community Features:</strong>
                        {' '}
                        Our website may contain functions such as discussion forums,
                        bulletin
                        boards, blogs, message boards, or other online community locations
                        (collectively “Community Features”) where the following rules apply:
                    </p>
                    <ul>
                        <li>
                            <p>
                                <strong>Your Profile information.</strong>
                                {' '}
                                When you create an account to use our
                                Community Features, you
                                do not have to disclose any of the “suggested” information
                                like your gender, birth date and real name.
                            </p>

                            <p>
                                You will, however, be able to build a public profile, which allows other
                                members to see
                                information that
                                you submit to us. You can privatize some of the information on your public
                                profile, such
                                as your e-mail
                                address. To protect your safety, please use your best judgment. We discourage
                                divulging
                                personal phone
                                numbers and addresses or other information that can be used to identify or
                                locate
                                you.
                            </p>

                            <p>
                                Under the Children’s Online Privacy Protection Act, we do not knowingly
                                collect Personal
                                Information from
                                children under the age of 13. Although you do not have to disclose your birth
                                date, if
                                any information is
                                disclosed in your profile or submissions that can identify you as a child
                                under the age
                                of 13, we reserve
                                the right to delete, edit, or reject such information, your entire profile or
                                your
                                submission.
                            </p>
                        </li>

                        <li>
                            <p>
                                <strong>Etiquette. Be courteous.</strong>
                                {' '}
                                In a community full of opinions and
                                preferences, people always
                                disagree. We encourage active discussions and welcome debate in
                                our Community Features. However, we do not tolerate personal
                                attacks, threats, verbal abuse, defamatory, obscene, hateful or
                                slanderous language, or deliberate disruption of discussions
                                with repetitive messages, meaningless messages, or &quot;spam.&quot; You
                                also are prohibited from using the Website to engage in any
                                illegal conduct. Please contact our site/privacy administrators
                                at
                                {' '}
                                <a href={contactEmailLink}>{contactEmail}</a>
                                {' '}
                                if you have concerns about the conduct of other users on our Website.
                                {' '}
                                <strong>
                                    We reserve the right in our sole
                                    discretion to temporarily suspend
                                    or permanently block access by
                                    anyone to all or part of our
                                    website at any time
                                </strong>
                                .
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Automated Tracking:</strong>
                                {' '}
                                Our website uses cookies to manage your session
                                information. If you use login, the system will save your
                                username and encrypted password to your computer in the
                                form of a &quot;Cookie,&quot; which is a small text file that is
                                saved to your browser.
                            </p>
                        </li>
                    </ul>
                </li>

                <li>
                    <p>
                        <strong>User Content Representations and Warranties:</strong>
                        {' '}
                        Our Website may allow you to upload
                        or share
                        content on the Website so that other users can
                        enjoy it. It’s great that you can upload or share
                        content on some of our Website; however, there are
                        definitely some things we do not permit you to
                        upload or share on our Website. Do not upload or
                        share anything on the Website such as messages,
                        posts, text, film, video, audio, photographic,
                        other recordings or images, or any other content
                        (collectively, “User Generated Content”) that you
                        do not have a right to use and share on the
                        Internet. By uploading or sharing any User
                        Generated Content on our website, you represent and
                        warrant that: (a) you are the original author or
                        creator of the User Generated Content and/or have
                        full copyright, title and interest in and to any
                        User Generated Content, (b) you have the full power
                        and authority to upload and/or share the User
                        Generated Content on the Website, (c) the use of
                        any element of the User Generated Content will not
                        violate or infringe upon the trademarks, trade
                        names, copyrights, patents, rights or privacy or
                        publicity or any other personal or proprietary
                        rights of any person or entity, and will not defame
                        or libel any person or entity, (d) you will not
                        publish falsehoods or misrepresentations that could
                        damage LPi or any third party; (e) you will not
                        submit material that is, obscene, threatening,
                        pornographic, harassing, hateful, racially or
                        ethnically offensive, or encourages conduct that
                        would be considered a criminal offense, give rise
                        to civil liability, violate any law, or is
                        otherwise inappropriate, (f) you will not post or
                        disseminate advertisements or solicitations of
                        business, or otherwise engage in commercial
                        activity on our Website, (g) you will not
                        impersonate another person, (h) you will not
                        solicit any user for material gain, and (i) you
                        will not produce spam throughout the Website
                        publicizing a product or event.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>User Generated Content License.</strong>
                        {' '}
                        Please note that if you post, upload or
                        otherwise make
                        available any User Generated Content on our Website, you will
                        still own the User Generated Content (assuming you have rights
                        to own it) but you are giving us the right to use your User
                        Generated Content. That means that if you send in, post, upload,
                        make available, or disclose to us in any way any User Generated
                        Content, you grant us, our affiliates and related entities, the
                        right use it any way we want in any medium without getting your
                        permission or having to pay you for it.
                    </p>

                    <p>
                        In legal terms, by providing us with any User Generated Content, you grant us and our
                        affiliates
                        and related
                        entities, a worldwide, royalty-free, perpetual, irrevocable, non-exclusive right and
                        fully
                        sub-licensable license
                        to use, copy, reproduce, distribute, publish, publicly perform, publicly display,
                        modify, adapt,
                        translate,
                        archive, store, and create derivative works from such User Generated Content, in any
                        form,
                        format, or medium, of
                        any kind now known or later developed. Without limiting the generality of the previous
                        sentence,
                        you authorize us
                        to share the User Generated Content across all website and online media platforms,
                        newspapers,
                        television and
                        radio broadcast stations, and any other media now or hereafter known affiliated with
                        us and to
                        use your name,
                        likeness and any other information in connection with our use of the material you
                        provide. You
                        waive any moral
                        rights you might have with respect to any User Generated Content you provide to us.
                        You also
                        grant us the right
                        to use any material, information, ideas, concepts, know-how or techniques contained in
                        any
                        communication you
                        provide or otherwise submit to us for any purpose whatsoever, including but not
                        limited to,
                        commercial purposes,
                        and developing, manufacturing and marketing commercial products using such
                        information. All
                        rights in this
                        paragraph are granted without the need for additional compensation of any sort to you.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Screening and Removal of User Generated Content.</strong>
                        {' '}
                        You acknowledge that we and/or
                        our designees
                        may or may not pre-screen User Generated
                        Content, and have the right (but not the
                        obligation), in our sole discretion, to move,
                        remove, block, edit, or refuse any User
                        Generated Content for any reason, including
                        without limitation that such User Generated
                        Content violates these Terms of Use or is
                        otherwise objectionable.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Risk from User Generated Content.</strong>
                        {' '}
                        We try to create an environment in which users
                        are posting
                        and discussing content that you will find useful, interesting
                        and appropriate; however we cannot and do not monitor or
                        manage all User Generated Content. Thus, we do not promise the
                        accuracy, integrity, or quality of the User Generated Content
                        and do not endorse it in any manner. In other words, enjoy
                        what other members post or share, but do it at your own risk.
                    </p>

                    <p>
                        Also, all User Generated Content provided on the Website is the sole responsibility of
                        the person
                        who
                        provided it. This means that you are entirely responsible for all User Generated
                        Content that
                        you
                        provide.
                    </p>

                </li>
                <li>
                    <p>
                        <strong>Third Party Sites:</strong>
                        {' '}
                        Our Website may allow you to link to third-party website.
                        Those
                        third-party website do not belong to us, and we have no control over, and
                        assume no responsibility for, the content, accuracy, usefulness, safety,
                        privacy policies, or practices of any third-party website. By using our
                        Website, you expressly relieve us and our affiliates and agents of any and
                        all liability arising from your use of any third-party website linked to our
                        Website. Enjoy the links, but at your own risk.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Warranty Disclaimer.</strong>
                        {' '}
                        We really hope you enjoy the Website and we also hope the
                        Website will
                        function properly. However, you agree that your use of the Website shall be
                        at your sole risk. To the fullest extent permitted by law, LPi, its
                        employees, Operational Service Providers (as defined in the
                        {' '}
                        {privacyPolicy}
                        ), representatives, affiliates
                        and agents disclaim all
                        warranties, express or implied, including, but not limited to the implied
                        warranties and conditions of merchantability, fitness for a particular
                        purpose and non-infringement, in connection with the Website and your use
                        thereof. LPi makes no warranties or representations about the accuracy or
                        completeness of the website, and assumes to the maximum extent permitted by
                        law no liability or responsibility for any (a) errors, mistakes, or
                        inaccuracies on the Website, (b) personal injury or property damage, of any
                        nature whatsoever, resulting from your access to and use of the Website,
                        (c) unauthorized access to or use of our secure servers and/or any and all
                        Personal Information that is not submitted using a secured transmission,
                        (d) interruption or the cessation of transmission to or from our Website,
                        (e) bugs, viruses, trojan horses, or the like, which may be transmitted to
                        or through our Website by any third-party, and/or (f) errors or omissions
                        on our Website or for any loss or damage of any kind incurred as a result
                        of your use of any content posted, e-mailed, transmitted, or otherwise made
                        available via the Website. LPi does not warrant, endorse, guarantee, or
                        assume responsibility for any product or service advertised or offered by a
                        third-party through the Website or any hyperlinked website or feature in
                        any banner or other advertising, and LPi will not be a party to or in any
                        way be responsible for monitoring any transaction between you and
                        third-party providers of products or services. As with the purchase of a
                        product or service through any medium or in any environment, you should use
                        your best judgment and exercise caution where appropriate.
                    </p>

                </li>
                <li>
                    <p>
                        <strong>Your Copyrighted Work.</strong>
                        {' '}
                        Just as LPi requires users to respect our copyrights, and
                        those of
                        our affiliates and partners, we respect the copyrights of others. If you
                        believe in good faith that your copyrighted work has been reproduced on
                        our Website without authorization in a way that constitutes copyright
                        infringement, you may notify us by sending mail to:
                    </p>

                    <p>
                        LPi
                        <br />
                        Attn: Webmaster
                        <br />
                        2875 South James Drive
                        <br />
                        New Berlin, WI 53151
                        <br />
                        By e-mail:
                        {' '}
                        <a href={contactEmailLink}>{contactEmail}</a>
                    </p>

                    <p>
                        The notice must have the following information as provided by federal law (Digital
                        Millennium
                        Copyright Act, 17
                        U.S.C. 512 (c)(3)):a. A physical or electronic signature of a person authorized to act
                        on behalf
                        of the owner of
                        an exclusive right that is allegedly infringed;b. Identification of the copyrighted
                        work claimed
                        to have been
                        infringed, or, if multiple copyrighted works at a single online site are covered by a
                        single
                        notification, a
                        representative list of such works at that site;c. Identification of the material that
                        is claimed
                        to be infringing
                        or to be the subject of infringing activity and that is to be removed or access to
                        which is to
                        be disabled, and
                        information reasonably sufficient to permit the service provider to locate the
                        material;d.
                        Information reasonably
                        sufficient to permit the service provider to contact the complaining party, such as an
                        address,
                        telephone number,
                        and, if available, an electronic mail address at which the complaining party may be
                        contacted;e.
                        A statement that
                        the complaining party has a good faith belief that use of the material in the manner
                        complained
                        of is not
                        authorized by the copyright owner, its agent, or the law; and a statement that the
                        information
                        in the
                        notification is accurate, and under penalty of perjury, that the complaining party is
                        authorized
                        to act on behalf
                        of the owner of an exclusive right that is allegedly infringed.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Limitation of Liability.</strong>
                        {' '}
                        In no event shall LPi, its officers, directors,
                        employees,
                        shareholders, representatives, Operational Service Providers,
                        affiliates or agents be liable to you for any direct, indirect,
                        incidental, special, punitive, or consequential damages whatsoever
                        resulting from any (a) mistakes, or inaccuracies of content on the
                        Website, (b) personal injury or property damage, of any nature
                        whatsoever, resulting from your access to and use of the Website, (c)
                        any unauthorized access to or use of our secure servers and/or any and
                        all non-secured Personal Information (d) any interruption or the
                        cessation of transmission to or from the Website, (e) any bugs,
                        viruses, trojan horses, or the like, which may be transmitted to or
                        through the Website by any third party, and/or (f) any errors or
                        omissions in any content or for any loss or damage of any kind incurred
                        as a result of your use of any content posted, e-mailed, transmitted, or
                        otherwise made available via the Website, whether based on warranty,
                        contract, tort or any other legal theory, and whether or not the
                        company is advised of the possibility of such damages. The foregoing
                        limitation of liability shall apply to the fullest extent permitted by
                        law in the applicable jurisdiction.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Indemnity.</strong>
                        {' '}
                        You agree to defend,
                        indemnify and hold harmless LPi, its affiliates,
                        subsidiaries, officers and directors, shareholders,
                        agents, employees and partners,
                        Operational Service Providers and any other parties
                        with whom LPi may contract to
                        provide its services, from and against any and all
                        claims, actions, suits, costs,
                        liabilities, judgments, obligations, losses, penalties,
                        fines or forfeitures,
                        expenses or damages (including without limitation,
                        reasonable legal fees and
                        expenses) of whatsoever kind and nature imposed on,
                        incurred by or asserted against
                        LPi arising out of any breach or alleged breach by
                        you of any representation,
                        warranty, covenant or obligation pursuant to these
                        Terms of Use or the failure to
                        fulfill any obligations relating to your account
                        incurred by you or any other person
                        using your account. We reserve the right to take
                        over the exclusive defense of any
                        claim for which we are entitled to indemnification
                        under this Section. In such event,
                        you shall provide us with such cooperation as is reasonably requested by us.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Termination.</strong>
                        {' '}
                        LPi has the right to terminate your access to use the Website for
                        any
                        reason, including for violation of these Terms of Use.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Governing Law and Jurisdiction.</strong>
                        {' '}
                        These Terms of Use and all questions relating to
                        the
                        performance, interpretation, breach or enforcement
                        of these Terms of Use, or the rights, obligations
                        and liabilities of the parties hereto, shall be
                        governed by the laws of the State of Wisconsin,
                        without regard to any conflict of laws provisions.
                        You agree that any and all disputes, claims or
                        litigation arising from or related in any way to
                        these Terms of Use and our relationship with you
                        hereunder shall be litigated only in a court of
                        competent jurisdiction located in the State of
                        Wisconsin, and you agree to be subject to personal
                        jurisdiction and venue in that location.
                    </p>
                </li>
            </ol>

            <div className={styles.termsConditionsRow}>
                <div className={styles.infoContainer}>
                    <h6 className={classNames(styles.headlineColor, themeContext === POL_THEME ? styles.headlineColorPOL
                        : styles.headlineColorMCO)}
                    >
                        FAQ
                    </h6>
                    <p>
                        To learn more about how to use&nbsp;
                        {siteTitle}
                        , and how it can work for you, check out our Frequently Asked Questions (FAQ) section.
                    </p>

                    <p>
                        <Link to={routes.HELP}><Button size="small">FAQ</Button></Link>
                    </p>
                </div>
                {/* Commenting out for now. We may have to change the
                    values in here or redo the layout a little.  */}
                {/* <div className={styles.infoContainer}>
                        <h6 className={classNames(styles.headlineColor,
                            themeContext === POL_THEME ? styles.headlineColorPOL
                                : styles.headlineColorMCO)}
                        >Webinars</h6>
                        <p>
                            Our free webinars are designed to help {siteVerbiage}
                            leaders and staff learn the foundational building
                            blocks and best practices for creating a vibrant {siteVerbiage}. Sign up&nbsp;
                            <a
                                target="_blank"
                                href="https://4lpi.com/webinar-series"
                                rel="noreferrer"
                            >
                                here
                            </a>
                            .
                        </p>
                    </div> */}
                <div className={styles.infoContainer}>
                    <h6 className={classNames(styles.headlineColor, themeContext === POL_THEME ? styles.headlineColorPOL
                        : styles.headlineColorMCO)}
                    >
                        Contact us
                    </h6>
                    <p>For more help about our products, please don&apos;t hesitate to contact us today.</p>
                    <p>
                        <a
                            target="_blank"
                            href="https://www.4lpi.com/contact-us"
                            rel="noreferrer"
                        >
                            <Button size="small">Contact Us</Button>
                        </a>
                    </p>
                </div>
            </div>
        </main>
    );
};

export default TermsConditions;
